
import { productClickReport } from './alibabareport';
/*
包含n个工具函数的模块
 */
/*
用户主界面路由
  dashen: /dashen
  laoban: /laoban
用户信息完善界面路由
  dashen: /dasheninfo
  laoban: /laobaninfo
判断是否已经完善信息? user.header是否有值
判断用户类型: user.type
 */
/*
返回对应的路由路径
 */
export function getRedirectTo(type, header) {
  let path
  // type
  if(type==='laoban') {
    path = '/laoban'
  } else {
    path = '/dashen'
  }
  // header
  if(!header) { // 没有值, 返回信息完善界面的path
    path += 'info'
  }

  return path
}

/**
 * 货源链接跳转
 * @param {*} item 
 */
export function huoyuanLink(item,jingxuanAddlogRequest)
{
  var urlParam = '&amug_biz=distribution&amug_fl_src=awakeId_1163';
  if(item.SourcePlatform == 'TaoteZhuKe' || item.PlatformType == 'TaoteZhuKe' )
  {
    const url = 'https://market.m.taobao.com/app/ltao-fe/ltao-lite/productdetail.html?ft=t&id='+item.ProductId+'&ex_outchal=dgj01'+urlParam;
    window.open(url, "newwindow",'height=850, width=500, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no');
  }
  else{
    const url = "https://detail.1688.com/offer/" + item.ProductId + ".html?sk=consign"+urlParam;
    window.open(url, "_blank");
    if(jingxuanAddlogRequest){
      var op={
          OperatorType: 'click_1688jinxuan_product_shop',
          PlatformType :'',
          Description:item.ProductId ,
          Remark:'点击1688精选商品',
          SiteType:'PC',
      }
      jingxuanAddlogRequest(op)
    }
  }
}

//跳转并且上报阿里
export function huoyuanLinkReport(item,pageKey)
{
  var urlParam = '&amug_biz=distribution&amug_fl_src=awakeId_1163';
  if(item.SourcePlatform == 'TaoteZhuKe' || item.PlatformType == 'TaoteZhuKe' )
  {
    const url = 'https://market.m.taobao.com/app/ltao-fe/ltao-lite/productdetail.html?ft=t&id='+item.ProductId+'&ex_outchal=dgj01'+urlParam;
    window.open(url, "newwindow",'height=850, width=500, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no');
  }
  else{
    const url = "https://detail.1688.com/offer/" + item.ProductId + ".html?sk=consign"+urlParam;
    window.open(url, "_blank");
    productClickReport([item.ProductId],pageKey)
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js